import { Fragment, h } from 'preact';
import UIElement from '../internal/UIElement/UIElement';
import RedirectButton from '../internal/RedirectButton';
import { BankTransferConfiguration, BankTransferState } from './types';
import BankTransferResult from './components/BankTransferResult';
import BankTransferInput from './components/BankTransferInput';
import { TxVariants } from '../tx-variants';

export class BankTransferElement extends UIElement<BankTransferConfiguration> {
    public static readonly type = TxVariants.bankTransfer_IBAN;
    public static readonly txVariants = [
        TxVariants.bankTransfer_IBAN,
        TxVariants.bankTransfer_BE,
        TxVariants.bankTransfer_NL,
        TxVariants.bankTransfer_PL,
        TxVariants.bankTransfer_FR,
        TxVariants.bankTransfer_CH,
        TxVariants.bankTransfer_IE,
        TxVariants.bankTransfer_GB,
        TxVariants.bankTransfer_DE,
        TxVariants.bankTransfer_AE,
        TxVariants.bankTransfer_AT,
        TxVariants.bankTransfer_AU,
        TxVariants.bankTransfer_BG,
        TxVariants.bankTransfer_CA,
        TxVariants.bankTransfer_EE,
        TxVariants.bankTransfer_ES,
        TxVariants.bankTransfer_FI,
        TxVariants.bankTransfer_HK,
        TxVariants.bankTransfer_HU,
        TxVariants.bankTransfer_IT,
        TxVariants.bankTransfer_JP,
        TxVariants.bankTransfer_LU,
        TxVariants.bankTransfer_NZ,
        TxVariants.bankTransfer_PT,
        TxVariants.bankTransfer_SG,
        TxVariants.bankTransfer_SK,
        TxVariants.bankTransfer_US
    ];

    public static readonly defaultProps = {
        showEmailAddress: true,
        showContextualElement: true,
        data: { shopperEmail: '' }
    };

    // @ts-ignore Double check why state extends all props
    public state: BankTransferState = {
        isValid: !this.props.showEmailAddress,
        data: {}
    };

    get isValid() {
        return !!this.state.isValid;
    }

    /**
     * Formats the component data output
     */
    formatData() {
        const { shopperEmail } = this.state.data;
        const subtype = this.type !== (TxVariants.bankTransfer_IBAN as string) ? { subtype: 'embedded' } : {};

        return {
            paymentMethod: {
                type: this.type,
                ...subtype
            },
            ...(shopperEmail && { shopperEmail })
        };
    }

    protected override componentToRender(): h.JSX.Element {
        if (this.props.reference) {
            return <BankTransferResult {...this.props} onActionHandled={this.onActionHandled} />;
        }

        return (
            <Fragment>
                {this.props.showEmailAddress && <BankTransferInput setComponentRef={this.setComponentRef} {...this.props} onChange={this.setState} />}
                <RedirectButton
                    {...this.props}
                    setComponentRef={this.setComponentRef}
                    showPayButton={this.props.showPayButton}
                    name={this.displayName}
                    onSubmit={this.submit}
                    payButton={this.payButton}
                />
            </Fragment>
        );
    }
}

export default BankTransferElement;
